<button
  type="button"
  class="eventq-panel-tab"
  [class.eventq-panel-tab--active]="active()"
  [attr.aria-selected]="active()"
  role="tab"
  (click)="selected.emit()"
>
  <span class="eventq-panel-tab__label">{{ label() }}</span>
</button>
